import styled from '@emotion/styled';

export const DateInput = styled.div`
	padding: var(--padding-2);
`;

export const Content = styled.div`
	width: 100%;
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	box-shadow: var(--container-box-shadow);
	padding: var(--padding-2);
`;

export const ContentRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	padding: var(--padding-2) var(--padding-4);
	border-inline-start: 2px solid transparent;

	cursor: pointer;
	&:hover {
		background-color: var(--table-selected-color);
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const Container = styled.div`
	display: block;
`;

export const Button = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background-color: var(--input-bg-color);
	border: 1px solid var(--border-color);
	padding: 0.8rem 1.2rem;
	border-radius: var(--small-border-radius);
	cursor: pointer;
	transition: all 0.2s ease;
	gap: 0.5rem;
	max-height: 4.5rem;
	min-height: 4.5rem;

	:hover {
		background-color: var(--table-selected-color);
	}
	:focus {
		border: 1px solid var(--blue);
		background-color: var(--table-selected-color);
	}

	body[dir='rtl'] & {
		max-height: 5.5rem;
		min-height: 5.5rem;
	}
`;
